import { render, staticRenderFns } from "./gamble.vue?vue&type=template&id=48be6f90&scoped=true&"
import script from "./gamble.vue?vue&type=script&lang=js&"
export * from "./gamble.vue?vue&type=script&lang=js&"
import style0 from "./gamble.vue?vue&type=style&index=0&id=48be6f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be6f90",
  null
  
)

export default component.exports